import React, { Component } from "react";

class StarRating extends Component {
  render() {
    const { rating } = this.props;

    return (
      <div style={{ display: "flex", gap: "4px", marginBottom: "20px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <svg
            key={star}
            width="15"
            height="15"
            viewBox="0 0 16 16"
            fill={star <= rating ? "#6B7B5E" : "none"}
            stroke={star <= rating ? "#6B7B5E" : "#BDB8B0"}
            strokeWidth="1.5"
          >
            <polygon points="8,1 10,6 15,6 11,9.5 12.5,15 8,12 3.5,15 5,9.5 1,6 6,6" />
          </svg>
        ))}
      </div>
    );
  }
}

class ClientQuoteCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      visible: true,
      direction: "next",
    };
    this.timer = null;
    this.goTo = this.goTo.bind(this);
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
  }

  componentDidMount() {
    this.timer = setInterval(this.next, 6000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  goTo(index, dir = "next") {
    if (!this.state.visible) return;
    this.setState({ visible: false, direction: dir });
    setTimeout(() => {
      this.setState({ current: index, visible: true });
    }, 360);
  }

  next() {
    const { current } = this.state;
    const { quotes } = this.props;
    this.goTo((current + 1) % quotes.length, "next");
  }

  prev() {
    const { current } = this.state;
    const { quotes } = this.props;
    this.goTo((current - 1 + quotes.length) % quotes.length, "prev");
  }

  render() {
    const { current, visible, direction } = this.state;
    const {
      quotes,
      label = "Client testimonials",
      title = "What clients are saying",
      subtitle = "A few kind words from people I've had the pleasure of working with.",
    } = this.props;

    const q = quotes[current];

    // Auto-generate initials from name if not provided
    const initials =
      q.initials ||
      q.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);

    const cardOuterClass =
      "cqc-card-outer " +
      (visible
        ? "shown"
        : direction === "next"
          ? "hidden-next"
          : "hidden-prev");

    return (
      <React.Fragment>
        <style>{`

          .cqc-root {
            font-family: 'DM Sans', sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 24px;
            min-height: 450px;
          }

          .cqc-wrapper {
            width: 100%;
            text-align: center;
          }

          .cqc-pill {
            display: inline-block;
            font-size: 12px;
            font-weight: 400;
            color: #3D3D35;
            border: 1px solid #C5BFB2;
            border-radius: 999px;
            padding: 5px 16px;
            margin-bottom: 20px;
            background: transparent;
            letter-spacing: 0.01em;
          }

          .cqc-heading {
            font-family: 'Fraunces', serif;
            font-size: 42px;
            font-weight: 600;
            color: #1E1E18;
            margin-bottom: 16px;
            line-height: 1.15;
            letter-spacing: -0.02em;
          }

          .cqc-subheading {
            font-size: 15px;
            font-weight: 300;
            color: #6B6B60;
            line-height: 1.65;
            max-width: 520px;
            margin: 0 auto 56px;
          }

          .cqc-card-outer {
            transition: opacity 0.36s ease, transform 0.36s ease;
          }
          .cqc-card-outer.hidden-next {
            opacity: 0;
            transform: translateY(14px);
          }
          .cqc-card-outer.hidden-prev {
            opacity: 0;
            transform: translateY(-14px);
          }
          .cqc-card-outer.shown {
            opacity: 1;
            transform: translateY(0);
          }

          .cqc-card {
            border-radius: 20px;
            padding: 48px 52px;
            text-align: left;
            transition: background 0.5s ease;
            position: relative;
          }

          .cqc-quote-mark {
            font-size: 72px;
            line-height: 0.75;
            color: rgba(0,0,0,0.15);
            display: block;
            margin-bottom: 20px;
          }

          .cqc-quote-text {
            font-size: 22px;
            font-weight: 400;
            line-height: 1.7;
            color: #1E1E18;
            margin-bottom: 40px;
          }

          .cqc-author-row {
            display: flex;
            align-items: center;
            gap: 14px;
          }

          .cqc-avatar {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            background: rgba(0,0,0,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 500;
            color: #1E1E18;
            flex-shrink: 0;
            letter-spacing: 0.04em;
          }

          .cqc-author-name {
            font-size: 14px;
            font-weight: 500;
            color: #1E1E18;
            margin-bottom: 2px;
          }

          .cqc-author-meta {
            font-size: 13px;
            font-weight: 300;
            color: rgba(30,30,24,0.55);
          }

          .cqc-stars-row {
            position: absolute;
            top: 48px;
            right: 52px;
          }

          .cqc-controls {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            margin-top: 36px;
          }

          .cqc-arrow {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #C5BFB2;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #3D3D35;
            transition: background 0.2s ease, border-color 0.2s ease;
          }

          .cqc-arrow:hover {
            background: #EDE8DF;
            border-color: #A8A39A;
          }

          .cqc-dots {
            display: flex;
            gap: 7px;
            align-items: center;
          }

          .cqc-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #C5BFB2;
            border: none;
            cursor: pointer;
            padding: 0;
            transition: background 0.3s ease, transform 0.3s ease;
          }

          .cqc-dot.active {
            background: #3D3D35;
            transform: scale(1.3);
          }

          @media (max-width: 600px) {
            .cqc-card { padding: 36px 28px; }
            .cqc-quote-text { font-size: 18px; }
            .cqc-heading { font-size: 30px; }
            .cqc-stars-row { position: static; margin-bottom: 8px; }
          }
        `}</style>

        <div className="cqc-root">
          <div className="cqc-wrapper">
            <div className={cardOuterClass}>
              <div
                className="cqc-card"
                style={{ background: q.bg || "#D9E8D4" }}
              >
                {/* <div className="cqc-stars-row">
                  <StarRating rating={q.rating} />
                </div> */}

                <span className="cqc-quote-mark">"</span>

                <p className="cqc-quote-text">{q.quote}</p>

                {/* <div className="cqc-author-row">
                  <div className="cqc-avatar">{initials}</div>
                  <div>
                    <div className="cqc-author-name">{q.name}</div>
                    <div className="cqc-author-meta">
                      {q.role} · {q.company}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="cqc-controls">
              <button
                className="cqc-arrow"
                onClick={this.prev}
                aria-label="Previous"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path
                    d="M10 3L5 8l5 5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <div className="cqc-dots">
                {quotes.map((_, i) => (
                  <button
                    key={i}
                    className={"cqc-dot" + (i === current ? " active" : "")}
                    onClick={() => this.goTo(i, i > current ? "next" : "prev")}
                    aria-label={"Go to quote " + (i + 1)}
                  />
                ))}
              </div>

              <button
                className="cqc-arrow"
                onClick={this.next}
                aria-label="Next"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path
                    d="M6 3l5 5-5 5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ClientQuoteCarousel;
